module.exports = __webpack_public_path__ + "img/desktop-map-MF.27c1d53e.svg";